import { render, staticRenderFns } from "./ReportCardPieChart.vue?vue&type=template&id=3d11333e"
import script from "./ReportCardPieChart.vue?vue&type=script&lang=ts"
export * from "./ReportCardPieChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports